import { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import { DayIndex } from 'components/mrp/components/AppointmentForm/components/RecurrencePatternBuilder/RecurrencePatternBuilder.types';
import dayjs from 'dayjs';
import {
  CreateAppointmentRequest,
  DayInWeekRequest,
  UpdateAppointmentRequest
} from 'generated/index';

const convertWeekDay = (idx: DayIndex): DayInWeekRequest => {
  switch (idx) {
    case 0:
      return 'MONDAY';
    case 1:
      return 'TUESDAY';
    case 2:
      return 'WEDNESDAY';
    case 3:
      return 'THURSDAY';
    case 4:
      return 'FRIDAY';
    case 5:
      return 'SATURDAY';
    case 6:
      return 'SUNDAY';
  }
};

export const convertFormFieldDataToPayload = (
  appointment: AppointmentFormFieldData,
  suppressWarnings: boolean = false
) => {
  const start = dayjs(appointment.start);
  const originalOccurrenceStart =
    appointment.originalOccurrenceStart &&
    dayjs(appointment.originalOccurrenceStart).toISOString();
  const end = dayjs(appointment.end);
  const durationInSeconds = Math.round(end.diff(start) / 1000);

  // convert to update model and update
  const payload = {
    ...(appointment.id && { entityId: appointment.id! }),
    activityEntityId: appointment.activity?.entityId,
    editAppointmentType: appointment.editAppointmentType,
    schedulingLabel: 'MRP',
    start: start.toISOString(),
    originalOccurrenceStart,
    // Todo: add below instead if BE fixes isRecurring, now we always add originalOccurrenceStart
    // ...(appointment.isRecurring && {
    //   originalOccurren-ceStart
    // }),
    durationInSeconds,
    notePublic: appointment.notePublic,
    noteInternal: appointment.noteInternal,
    workPlaceEntityId: appointment.planEntities?.['WORKPLACE']?.[0]?.entityId,
    clientEntityIds:
      appointment.planEntities?.['CLIENT']
        .filter(({ entityId }) => !!entityId)
        .map(({ entityId }) => entityId) || [],
    employeeEntityIds:
      appointment.planEntities?.['EMPLOYEE']
        .filter(({ entityId }) => !!entityId)
        .map(({ entityId }) => entityId) || [],
    resourceEntityIds:
      appointment.planEntities?.['RESOURCE']
        .filter(({ entityId }) => !!entityId)
        .map(({ entityId }) => entityId) || [],
    recurrenceRule:
      (appointment.editAppointmentType === 'ONLY_THIS' &&
        appointment.isRecurring) ||
      appointment.recurrencePattern?.recurrenceRule === 'none'
        ? null
        : {
            periodType:
              appointment.recurrencePattern!.recurrenceRule === 'daily'
                ? 'DAY'
                : 'WEEK',
            recurrenceRange: {
              type: appointment.recurrencePattern?.recurrenceRangeType,
              end:
                appointment.recurrencePattern?.recurrenceRangeType ===
                'END_ON_DATE'
                  ? appointment.recurrencePattern?.recurrenceEnd
                  : undefined
            },
            interval: appointment.recurrencePattern?.recurrenceInterval,
            dayInWeekSet:
              appointment.recurrencePattern?.daysSelected?.map((x) =>
                convertWeekDay(x)
              ) || []
          },
    recurrenceExceptionUpdateType: appointment.recurrenceExceptionUpdateType,
    suppressWarnings
  };

  return payload as CreateAppointmentRequest & UpdateAppointmentRequest;
};
